export default __webpack_public_path__ + "static/media/Contact_Email.71ef52e7.svg";